<template>
    <div>
        <v-row id="product__rowpadding" v-if="mediachannal == 3">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Electronic Type <span id="required">*</span>:</v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-select
                    :items="all_electronic_type"
                    dense
                    outlined
                    attach
                    chips
                    v-model="electronic_type"
                />
            </v-col>
        </v-row>
        <v-row id="product__rowpadding" v-else-if="mediachannal == 5 || mediachannal == 10">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Digital Source : </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-radio-group row v-model="digital_source">
                    <v-radio  label="Only Desktop" :value="0"/>
                    <v-radio label="Only Mobile" :value="1"/>
                </v-radio-group>
            </v-col>
        </v-row>
        <div v-else-if="mediachannal == 6">
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">Number of Updates/Tweets : </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-text-field  outlined dense v-model="number_updates_tweets"/>
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">Number of Fans/Followers : </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-text-field  outlined dense v-model="number_fans_followers"/>
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">
                    External Link <span id="required">*</span>: </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-text-field  outlined dense v-model="external_link"/>
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">Social Media Ad Type <span id="required">*</span>: </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-select 
                        :items="all_social_media_add_type"
                        dense
                        outlined
                        v-model="social_media_add_type"
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    name: 'MediaChannal',
    computed: {
        ...mapGetters({
            all_electronic_type: 'ProductData/getElectronicType',
            all_social_media_add_type: 'ProductData/getSocialMediaAddType',
            mediachannal: 'ProductData/getStateMediaChannel',
        }),
        electronic_type: {
            get: function() {
                return this.$store.getters['ProductData/getMediaChannelElectronicType']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/setMediaChannelElectronicType', o)
            },
        },
        digital_source: {
            get: function() {
                if(this.$store.getters['ProductData/getMediaChannelDigitalSource']=="")
                 this.$store.dispatch('ProductData/setMediaChannelDigitalSource', 0)
                
                return this.$store.getters['ProductData/getMediaChannelDigitalSource']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/setMediaChannelDigitalSource', o)
            },
        },
        number_updates_tweets: {
            get: function() {
                return this.$store.getters['ProductData/getMediaChannelNumberUpdatesTweets']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/setMediaChannelNumberUpdatesTweets', o)
            },
        },
        number_fans_followers: {
            get: function() {
                return this.$store.getters['ProductData/getMediaChannelNumberFansFollowers']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/setMediaChannelNumberFansFollowers', o)
            },
        },
        external_link: {
            get: function() {
                return this.$store.getters['ProductData/getMediaChannelExternalLink']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/setMediaChannelExternalLink', o)
            },
        },
        social_media_add_type: {
            get: function() {
                return this.$store.getters['ProductData/getMediaChannelSocialMediaAddType']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/setMediaChannelSocialMediaAddType', o)
            },
        },
    }
}
</script>